import {Component, Directive, Inject, ElementRef, ViewChild, ContentChildren, QueryList,OnInit} from '@angular/core';

import {TranslateService} from 'ng2-translate/ng2-translate';
import { EventsService } from './shared/Events.service';

declare var componentHandler: any;

@Component({
    selector: 'main-app',
   template: require('./app.component.html')
 
})


export class AppComponent implements OnInit {
    isVoterSearch: boolean = false;
    element: ElementRef;
    drawerToggle:Element;
    tabBar:Element;
    drawer:Element;
    obfuscator:Element;
    logoPath:string = "./images/Political_Icon1_100x100.png";
    userLang:string = 'en';
    checkVal: boolean = false;
    modalDialogShow:boolean = false;
    modalDialogText:string = "";
    
    //Note:  need to inject the TranslateService here in order to set the language of the trnaslator
    constructor(private _eventsService: EventsService, el: ElementRef, private translate: TranslateService){
      
        this.element = el;

    }
    
    ngOnInit() {

        componentHandler.upgradeAllRegistered();

        // hide the drawer toggle button
        this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
        this.drawerToggle["style"].display = "none";

        //toggle the drawer panel
        this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
        !this.drawer.classList.contains('is-visible') ? this.drawer.classList.toggle('is-visible') : console.log("This is the initial load");
        this.drawer.setAttribute("aria-hidden", "false");

        this.tabBar = document.getElementsByClassName('mdl-layout__tab-bar')[0];
        this.tabBar ? this.tabBar.setAttribute("aria-hidden", "true") : null;
        //enable this to change the default drawer toggle icon 
        // this.changeIcon()
  
        //handle the active tab event
        this._eventsService.activeTab$.subscribe(tabview => {

                // this.tabBar.scrollLeft = 20;
        

                let tabpanels: any = document.querySelectorAll('.mdl-layout__tab-panel');
                let tabs: any = document.querySelectorAll('.mdl-layout__tab');
                let view: any = tabview;
                let leftPos:any;

                for (let tabpanel of tabpanels) {
                    tabpanel.classList.contains('is-active') ? tabpanel.classList.remove('is-active') : null;
                    tabpanel.id === tabview ? tabpanel.classList.add('is-active') : null;

                }

                for (let tab of tabs) {
                    tab.classList.contains('is-active') ? tab.classList.remove('is-active') : null;
                    // tab.hash === "#" + tabview ? tab.classList.add('is-active') : null;
                    
                    //set the active tab and get the offset position
                    if (tab.hash === "#" + tabview) {
                        tab.classList.add('is-active')
                        leftPos = tab["offsetLeft"] - 60;
                    }

                }

                //scroll the tab bar to the  position of the selected tab 
                this.tabBar.scrollLeft = leftPos;

                let menuItems:any = document.querySelectorAll('.mdl-menu__item');
                for (let menuItem of menuItems) {
                    menuItem.classList.contains('selectedMenuItem') ? menuItem.classList.remove('selectedMenuItem') : null;
                    if (menuItem.getAttribute("value") === tabview) {
                        menuItem.classList.add('selectedMenuItem')
                    }
                }
            }
        );

        //handle search event
        this._eventsService.searchInvoked$.subscribe(
            search => {

                this.isVoterSearch = true;

                // // show the drawer toggle button
                // this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
                // this.drawerToggle["style"].display = "block";

                //toggle the drawer panel
                this.drawer = document.getElementsByClassName('mdl-layout__drawer')[0];
                this.drawer.classList.contains('is-visible') ? this.drawer.classList.toggle('is-visible') : console.log("This is the initial load");
                // this.drawer.setAttribute("aria-hidden", "false");
                //toggle the obfuscation panel
                this.obfuscator = document.getElementsByClassName('mdl-layout__obfuscator')[0];
                this.obfuscator.classList.contains('is-visible') ? this.obfuscator.classList.toggle('is-visible') : console.log("This is the initial load");

                this.tabBar ? this.tabBar.setAttribute("aria-hidden", "false") : null;

                //activate the tab right chevron button for mobile devices
                if(window.innerWidth <= 800 && window.innerHeight <= 1024) {
                    let tabRightChevron :any = document.getElementsByClassName('mdl-layout__tab-bar-right-button')[0];
                    !tabRightChevron.classList.contains('is-active') ? tabRightChevron.classList.add('is-active')  : null;
                    // tabRightChevron.textContent = "more";
                }


                console.log("Received location search event!");
            }

        );

        // this.userLang = navigator.language.split('-')[0]; // use navigator lang if available
        this.userLang = /(es|en)/gi.test(this.userLang) ? this.userLang : 'en';

        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang('en');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use(this.userLang);

        this._eventsService.languageChanged$.subscribe(language => {
            componentHandler.upgradeAllRegistered();
            this.userLang = language;
            this.translate.use(this.userLang);
            
        });

    }

    //chnage the icon from the default hamburger menu icon
    //   changeIcon() {
    //         var _db = document.querySelector('.mdl-layout__drawer-button i');
    //         if (_db) {
    //             _db.textContent = 'home';
    //         }
    //         if(!_db) {
    //             setTimeout(function() {
    //                 this.changeIcon();
    //             }, 50);
    //         }
    //     }

        onLangToggle (value:any) {
            //notify of langauge chnage for help documentation
            this.checkVal = value
            //toggle from english to spanish
            this.checkVal ? this._eventsService.updateLanguage('es'): this._eventsService.updateLanguage('en') ;
        }
 
    onGeolocationError(errorString:string){
        this.modalDialogShow = true;
        this.modalDialogText = errorString;
    }

    showDrawer():void{
        // show the drawer toggle button
        //this.drawerToggle = document.getElementsByClassName('mdl-layout__drawer-button')[0];
        //this.drawerToggle["style"].display = "block";

        //toggle the drawer panel
        var drawer:Element = document.getElementsByClassName('mdl-layout__drawer')[0];
        !drawer.classList.contains('is-visible') ? drawer.classList.toggle('is-visible') : console.log("This is the initial load");
        //toggle the obfuscation panel
        var obfuscator:Element = document.getElementsByClassName('mdl-layout__obfuscator')[0];
        !obfuscator.classList.contains('is-visible') ? obfuscator.classList.toggle('is-visible') : console.log("This is the initial load");
    }

    showPanel(tabName:string):void{
        //set the active tab
        this._eventsService.setActiveTab(tabName);
    }

    showFAQ(tabName:string):void{
        //set the active tab
        this._eventsService.setActiveTab("tabFAQ");
    }
}


// WEBPACK FOOTER //
// ./app/app.component.ts